import { lazy } from 'react';

import ReactDOM from 'react-dom/client';

import { AppLoader } from '@eduzz/ui-layout';

// Lazy para o loader pintar antes do bundle do App carregar (padrão @eduzz/ui-layout).
const App = lazy(() => import('@/App'));

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <AppLoader>
    <App />
  </AppLoader>
);
